import queryString from 'query-string'

import { trackSignUpStart } from '@/helpers/telemetry/trackSignUpStart'

import windowLocationAssign from './windowLocationAssign'

const redirectToAuth = () => {
  const qs =
    queryString.stringify({
      redirectAfterLogin: window.location.pathname + window.location.search,
    }) || ''

  windowLocationAssign(`/acct/signin?${qs}`)
}

const redirectSignUp = () => {
  trackSignUpStart()

  const qs =
    queryString.stringify({
      redirectAfterSignup: window.location.pathname,
    }) || ''

  windowLocationAssign(`/acct/signup?${qs}`)
}

export { redirectToAuth, redirectSignUp }
